import { MenuIcon, XIcon } from "@heroicons/react/solid";
import { Link } from "gatsby";
import React, { Component } from "react";
import { connect } from "react-redux";
import LogoBlack from "../../images/logo.png";
import { signOut } from "../../store/actions/authActions";
import { authStateInterface } from "../../store/reducers/authReducer";
import { utilsStateInterface } from "../../store/reducers/utilsReducer";
import IconButton from "./IconButton";

interface Props {
  authStore: authStateInterface;
  utilsStore: utilsStateInterface;
  page: string;
}

const navigation = [
  { name: "About Us", href: "/aboutUs" },
  { name: "FAQs", href: "/faqs" },
  { name: "For NGO", href: "/forNGO" },
];

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

class Header extends Component<Props> {
  state = {
    mobileMenu: false,
  };

  handleSignOut = () => {
    signOut(this.props.utilsStore.firebase);
  };

  handleOpenMobileMenu = () => {
    this.setState({
      mobileMenu: !this.state.mobileMenu,
    });
  };

  renderLogo = () => {
    return (
      <Link to="/">
        <img className="h-6 w-auto lg:h-7" src={LogoBlack} alt="MySukarela" />
      </Link>
    );
  };

  renderHeaderLink = (type: string, isLaptop: boolean) => {
    let linkNav = "";
    let linkTitle = "";
    switch (type) {
      case "signIn":
        linkTitle = "Sign In";
        linkNav = "/auth/signIn";
        break;
    }

    if (linkNav && linkTitle) {
      if (isLaptop) {
        return (
          <Link to={linkNav}>
            <span className="ml-8 whitespace-nowrap text-base font-bold text-gray-500 hover:text-gray-900">
              {linkTitle}
            </span>
          </Link>
        );
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  renderHeaderComponent = () => {
    const headerLinkList: any[] = [];

    navigation.map((eachNavigation, index) => {
      headerLinkList.push(
        <div className="grid grid-cols-2 mt-4 gap-x-8" key={index}>
          <Link
            to={eachNavigation.href}
            className="text-base font-bold text-gray-700 hover:text-red-600"
          >
            {eachNavigation.name}
          </Link>
        </div>
      );
      return null;
    });
    return <>{headerLinkList}</>;
  };

  render() {
    return (
      <div className="relative bg-white w-full">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex justify-between items-center border-b-2 border-gray-100 py-6 md:justify-start md:space-x-10">
            <div className="flex justify-start lg:w-0 lg:flex-1">
              <span className="sr-only">MySukarela</span>
              {this.renderLogo()}

              <div className="hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={classNames(
                      this.props.page === item.name
                        ? "border-red-600 text-red-600"
                        : "border-transparent text-gray-500 hover:text-red-500 hover:border-red-600",
                      "inline-flex items-center px-1 pt-1 border-b-2 text-base font-bold"
                    )}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </div>

            <div className="-mr-2 -my-2 md:hidden">
              <IconButton
                icon={<MenuIcon className="h-5 w-5 text-gray-400" />}
                onClick={this.handleOpenMobileMenu}
                className="rounded-md"
              />
            </div>
            <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0">
              {this.props.authStore.userAuth ? (
                <Link to="/dashboard">
                  <span className="ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-bold text-white bg-red-600 hover:bg-red-500">
                    My Dashboard
                  </span>
                </Link>
              ) : (
                <>
                  <Link to="/auth/signIn">
                    <span className="ml-8 whitespace-nowrap text-base font-bold text-gray-500 hover:text-red-600">
                      Sign In
                    </span>
                  </Link>
                  <Link to="/auth/signUp">
                    <span className="ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-bold text-white bg-red-600 hover:bg-red-500">
                      Sign Up
                    </span>
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>

        {this.state.mobileMenu && (
          <div className="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden z-30">
            <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
              <div className="pt-5 pb-6 px-5">
                <div className="flex items-center justify-between">
                  <div>{this.renderLogo()}</div>
                  <div className="-mr-2">
                    <IconButton
                      icon={<XIcon className="h-5 w-5 text-red-600" />}
                      onClick={this.handleOpenMobileMenu}
                    />
                  </div>
                </div>
              </div>
              <div className="pt-3 pb-6 px-5 space-y-6">
                {this.props.authStore.userAuth ? (
                  <div>
                    {this.renderHeaderComponent()}
                    <Link to="/dashboard">
                      <span className="w-full flex font-bold items-center justify-center px-4 py-2 mt-4 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-red-600 hover:bg-red-500">
                        My Dashboard
                      </span>
                    </Link>
                  </div>
                ) : (
                  <div>
                    {this.renderHeaderComponent()}
                    <Link to="/auth/signUp">
                      <span className="w-full flex font-bold items-center justify-center px-4 py-2 mt-4 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-red-600 hover:bg-red-500">
                        Sign up
                      </span>
                    </Link>
                    <p className="mt-6 text-center text-base font-medium text-gray-500">
                      Existing volunteers ?{" "}
                      <Link to="/auth/signIn">
                        <span className="text-red-600 font-bold hover:text-red-500">
                          Sign in
                        </span>
                      </Link>
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    authStore: state.authStore,
    utilsStore: state.utilsStore,
  };
};

export default connect(mapStateToProps)(Header);
